import React from "react";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import ContactForm from "./ContactForm";
import "./contact.css";

export default function ContactEnquiry({ language }) {
  return (
    <details className="ContactEnquiry">
      <summary>
        {language === 0 ? "Skicka en förfrågan" : "Send an enquiry"}
        <ArrowForwardIcon aria-hidden="true" />
      </summary>
      <ContactForm />
    </details>
  );
}
